export const postToTelegram = async (message = 'New order') => {
  try {
    const telegramBotToken = '5798934041:AAHxNhrHOUYEUjAWeZJEMGDTpRFu0wH_eDc';
    const telegramChannelId = '-1001873828830';
    const url = `https://api.telegram.org/bot${telegramBotToken}/sendMessage?chat_id=${telegramChannelId}&text=${message}`;
    await fetch(url, {
      method: 'GET'
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerPost = (eventName, payload) => {
  try {
    if (!eventName) {
      return;
    }
    if (window && typeof window.dataLayer !== 'undefined') {
      console.log('DATA LAYER EVENT', eventName, payload);
      const additionalInfo = payload || {};
      window.dataLayer.push({
        event: eventName,
        ...additionalInfo
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const getExchangeRate = async () => {
  try {
    const defaultRate = '20.00';
    const googleApiKey = 'AIzaSyChYJoH7dq2Xh0QVTeoiDnO-dTkZgDVLQs';
    const sheetId = '16zMDe5RhE_lzz2KDpr9KOBK2JEiL_0G48dsHAxYJgYA';
    const driveSheetUrl = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/A1:B1?key=${googleApiKey}`;
    const headers = new Headers();
    const res = await fetch(driveSheetUrl, {
      method: 'GET',
      headers
    });
    const data = await res.json();
    const stringRate = data?.values?.[0]?.[1];
    return stringRate || defaultRate;
  } catch (e) {
    console.log(e);
  }
};
